import * as React from 'react'
import { useReducer } from 'react'
import { closingReqContext } from './closingReqContext'
import { reducer, initialState } from '../state'

export function ClosingReqContextProvider(props: {
  children: React.ReactNode
}) {
  const { children } = props

  const value = useReducer(reducer, initialState)

  return (
    <closingReqContext.Provider value={value}>
      {children}
    </closingReqContext.Provider>
  )
}
